export class ChatConfig {
  public static readonly DEFAULT_TITLE = 'Untitled Chat';

  public static readonly MAX_MESSAGE_LENGTH = 128_000;
}
